"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourStepsEditor = void 0;
const react_1 = require("@thesisedu/react");
const icons_1 = require("@thesisedu/react/icons");
const react_2 = __importDefault(require("react"));
const TourStepEditor_1 = require("./TourStepEditor");
function TourStepsEditor() {
    const { form } = react_1.Form.useReactFormContext();
    const { fields, append, remove, move } = react_1.Form.useFieldArray({
        name: 'steps',
        control: form.control,
    });
    return (react_2.default.createElement(react_1.VSpaced, { space: '@size-l', align: 'stretch' },
        fields.map((field, index) => {
            return (react_2.default.createElement("div", { key: field.id },
                react_2.default.createElement(TourStepEditor_1.TourStepEditor, { prefix: `steps.${index}`, onRemove: () => {
                        remove(index);
                    }, onMoveUp: () => {
                        move(index, Math.max(0, index - 1));
                    }, onMoveDown: () => {
                        move(index, Math.min(fields.length - 1, index + 1));
                    }, canMoveUp: index > 0, canMoveDown: index < fields.length - 1 })));
        }),
        react_2.default.createElement(react_1.Button, { icon: react_2.default.createElement(icons_1.Plus, null), children: 'Add Step', onClick: e => {
                e.preventDefault();
                append({});
            } })));
}
exports.TourStepsEditor = TourStepsEditor;
//# sourceMappingURL=TourStepsEditor.js.map